export default __webpack_public_path__ + "static/media/Logo.b53a266b.jpeg";